import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import banner from "../../../assets/images/MultiDosePill/pill-source-web-hero.webp";
import { FaRegDotCircle } from "react-icons/fa";
import img from "../../../assets/images/MultiDosePill/image0.png";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const MDPP = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <Container>
      <TopServiceBanner title=" Pill Packaging" banner={banner} />
      <Inner>
        <SubTitle>
          If you have been prescribed multiple medications at various times of
          day, you may find the process a bit overwhelming. Did you remember to
          take this one? Maybe you forgot to take that one? As you know,
          precision is the key to proper medication dosages and effective
          treatment. But there is good news. Dispill® Multi-dose Pill Packaging
          makes these doses more manageable to take than ever.
          <br />
          <br />
          Since 1995 Dispill® has been dedicated to helping patients adhere to
          dosing easier and more accurately. And at Lincourt  Pharmacy, we are
          pleased to offer innovative pill packaging to our valued patients.
          <br />
          <br />
          Want to know more about pill packaging? Keep reading or contact us to
          speak with our friendly staff.
        </SubTitle>
        <Title>What is Multi-Dose Packaging?</Title>
        <SubTitle>
          This brilliantly created pill packaging system helps patients stick to
          their proper medication dosages, times, and more. That way, your local
          Lincourt  Pharmacist can place all your medications in easy-to-open
          blister packaging that is convenient and ready to use. It comes in
          cards of 28 or 32 cells. And because they are packaged right in your
          pharmacy, you know you are getting the proper medications at the
          correct times and eliminating mix-ups.
          <br />
          <br />
          Bundling your medications together in a simple way with multi-dose
          pill packaging by date and time is a genius way to simplify your
          healthcare.
          <br />
          <br />
          Dispill® medication packaging offers convenience and accountability
          for those who take multiple doses at various times of the day. Our
          pill packaging provides the following:
          <UUl>
                <LLi>
                  <FaRegDotCircle />
                  Color-coded packaging by the time of day.
                </LLi>
                <LLi>
                  <FaRegDotCircle />
                  Convenience and simplicity.
                </LLi>
                <LLi>
                  <FaRegDotCircle />
                  Detached and portable packaging.
                </LLi>
                <LLi>
                  <FaRegDotCircle />
                  Packs filled by your pharmacist, so you know the dosages are accurate.
                </LLi>
              </UUl>
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>The Benefits of Pill Packaging</MiddleTextLeft>
              <Ul>
                <Li>
                  <FaRegDotCircle />
                  The information on the packaging is easy to read and
                  organized. Just ask
                  the pharmacist.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  Each blister opens with an easy-to-pull tab and perforations.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  Labels printed in 87 languages and dialects.
                </Li>
                <Li>
                  <FaRegDotCircle />
                  High quality and cost-effective packaging.
                </Li>
              </Ul>
              <MiddleSubTitle>
                Note: These packages are designed to be easy to open. We
                recommend you keep this and all medication out of the reach of
                children.
              </MiddleSubTitle>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img} alt="multi dose pill packaging" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>
        <Title>Let Lincourt  Pharmacy Help You Stay on Schedule</Title>
        <SubTitle>
          Dispill® Multi-Dose Pill Packaging filled by the caring and friendly
          staff at Lincourt  Pharmacy almost guarantees you don’t miss or mix
          up a dosage. And, as long as you take the prescribed blister at the
          recommended time, you will get all you need with one pull of an
          easy-open tab.
          <br />
          <br />
          Your Lincourt  Pharmacy wants the very best for your healthcare and
          wellness. This is just one more way we are looking out for the
          patients of Lincourt  and the surrounding areas. Integrating our
          modern take on medicine dosing with our old school values, patients
          receive the best in pharmacy care.
          <br />
          <br />
          Making changes in how you take your medications and supplements can be
          a scary decision. However, our team will make sure the transition is
          easy to understand and customized to your wellness needs.
          <br />
          <br />
          Contact us today to get started converting your prescriptions and
          supplements to Multi-Dose Packaging.
        </SubTitle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />

    </Container>
  );
};

export default MDPP;


const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: justify;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 10rem;
  padding-top: 1rem;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 10rem;
  padding: 3rem;
  gap: 1rem;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const MiddleInnerLeft = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const UUl = styled.ul`
  display: grid;
  gap: 0.5rem;
  padding-top: 2rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const LLi = styled.li`
  letter-spacing: 1px;
  list-style: disc;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
